import { css } from 'lit';

export default [
  css`
  ul {
    color: var(--tenable-form-error-text-color, #ffffff);
    background: var(--tenable-form-error-background, var(--tenable-form-error-color, #9C2121));
    border: 1px solid var(--tenable-form-error-border-color, transparent);
    border-radius: 3px;
    padding: .5rem;
    margin-bottom: 1rem;
    list-style: none;
  }

  li {
    color: var(--tenable-form-error-text-color, #ffffff);
    line-height: 1.2;
  }
  `,
];
